import React from 'react';
import { Dialog, DialogContent, Box, Typography, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import { QRCodeSVG } from 'qrcode.react';
import { IQRCode } from 'types/banking';

interface ViewQRCodeModalProps {
  open: boolean;
  onClose: () => void;
  qrCode: IQRCode | null;
}

const ViewQRCodeModal = ({ open, onClose, qrCode }: ViewQRCodeModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          paddingTop: 2,
        },
      }}
    >
      <DialogContent sx={{ px: 4, pb: 4 }}>
        <Box position="relative" display="flex" alignItems="center" justifyContent="center" mb={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <QrCode2OutlinedIcon sx={{ color: 'primary.main' }} />
            <Typography fontWeight={600} fontSize={16}>
              Visualizar QRCode
            </Typography>
          </Box>

          <IconButton onClick={onClose} size="small" sx={{ position: 'absolute', right: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="body2" color="text.secondary" textAlign="center" mb={3}>
          Detalhes do QRCode gerado
        </Typography>

        <Box display="flex" justifyContent="center" mb={3} minHeight={200} alignItems="center">
          {qrCode?.emvqrcps ? <QRCodeSVG value={qrCode.emvqrcps} size={200} /> : <CircularProgress />}
        </Box>

        {qrCode?.amount && (
          <>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Valor
            </Typography>
            <Typography textAlign="center" fontSize={24} fontWeight={700} color="primary.main">
              {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(qrCode.amount)}
            </Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewQRCodeModal;
